export class HttpError {
  public status: number;

  constructor(response: Response) {
    this.status = response.status;
  }
}
